/*
 * /timeline-events (page)
 */
import { createFileRoute } from "@tanstack/react-router"
import { Container, Divider, Page, PageHeader } from "@psychology/react-ui"
import { ArrowLeft } from "lucide-react"
import { TimelineEventList } from "../../features/timeline-events/components/timeline-event-list"
import { trpc } from "../../trpc"
import { authPageLoader } from "../../utils/auth.utils"

export const Route = createFileRoute("/timeline-events/")({
	component: TimelineEventsPage,
	loader: authPageLoader,
})

function TimelineEventsPage() {
	const { user } = Route.useLoaderData()

	const {
		data: events,
		isLoading,
		refetch,
	} = trpc.timelineEvent.getAllByFilter.useQuery({
		where: { userId: user.id },
		sort: { column: "date", direction: "desc" },
	})

	return (
		<Page centerVertical={false}>
			<Container width={"xl"} padding={"lg"} gap={"sm"}>
				<PageHeader
					title={"Timeline"}
					left={{
						href: "/dashboard",
						label: "Dashboard",
						Icon: <ArrowLeft size={20} />,
					}}
				/>
				<Divider />
				<TimelineEventList
					userId={user.id}
					events={events || []}
					isLoading={isLoading}
					onChanged={refetch}
				/>
			</Container>
		</Page>
	)
}
